import Swiper from 'swiper'
import { Navigation, Autoplay } from 'swiper/modules'

let config

export const initSwiper = () => {
	const sliders = document.querySelectorAll('[data-swiper]')

	if (!sliders.length) return

	sliders.forEach((slider) => {
		const type = slider.getAttribute('data-swiper')

		switch (type) {
			case 'banner':
				config = {
					loop: true,
					speed: 750,
					slidesPerView: 1,
					autoplay: true,
					modules: [Autoplay]
				}
			break;
			case 'features':
				config = {
					speed: 750,
					spaceBetween: 18,
					slidesPerView: 1.15,
					breakpoints: {
						651: {
							spaceBetween: 24,
							slidesPerView: 2.2,
						}
					}
				}
			default:
			break;
		}

		const swiper = new Swiper(slider, {...config })

	})
}

export default () => {}
